import {createSlice} from '@reduxjs/toolkit';
import {msg, str} from '@lit/localize';
import {routeUrl} from '../util/routeUrl';
import {artworkSlice} from './artworkSlice';
import store from '../store';

const statusInitialState = {
	status: 'idle',

	// ui state
	headerDropdownOpened: null,

	// base urls
	host: null,
	baseUrl: null,
	apiUrl: null,

	//tenant
	tenant: 'arc',

	paddleToken: null,

	allowDownloads: false,

	// route
	route: {
		route: null,
		params: null,
		query: null,
	},

	// ui language
	lang: '',

	// content language
	currentContentLanguage: 'de',
	availableContentLanguages: ['de', 'en'],

	// gui status
	showArtworksFilter: false,

	dialog: {
		open: false,
		message: '',
		title: '',
		warningMessage: '',
		artworkTitle: '',
		showConfirmButton: true
	},

	error: {},
	message: null,
	messageType: null,
	showMessage: false,

	formChanged: false,
};

function updateRoute(state, action) {
	/*
	state.route = {
		route: action.payload.route,
		params: action.payload.params,
		query: action.payload.query
	};
	state.lang = action.payload.params?.language ?? state.lang;
	*/
	document.removeEventListener('confirm', () => updateRoute(state, action));
	window.history.pushState(
		{},
		null,
		routeUrl(action.payload.route, action.payload.params, action.payload.query)
	);
	window.dispatchEvent(new CustomEvent('route'));
}

export const statusSlice = createSlice({
	name: 'profile',
	initialState: statusInitialState,
	reducers: {
		openDialog: (state, action) => {
			state.dialog.message = action.payload.message;
			state.dialog.title = action.payload.title || '';
			state.dialog.warningMessage = action.payload.warningMessage || '';
			state.dialog.artworkTitle = action.payload.artworkTitle || '';
			state.dialog.labelConfirm = action.payload.labelConfirm || '';
			state.dialog.labelCancel = action.payload.labelCancel || '';
			state.dialog.showConfirmButton = action.payload.showConfirmButton !== false;
			document.dispatchEvent(new CustomEvent('open-dialog'));
		},
		closeDialog: (state) => {
			state.dialog.message = '';
			state.dialog.title = '';
			state.dialog.warningMessage = '';
			state.dialog.artworkTitle = '';
		},
		navigateTo: (state, action) => {
			// close header menus
			state.headerDropdownOpened = null;

			if (!state.formChanged) {
				updateRoute(state, action);
			} else {
				state.dialog.message = msg('The Form has unsaved changes. Do you really want to leave?');
				state.dialog.warningMessage = '';
				state.dialog.title = msg('Unsaved Changes');
				state.dialog.labelConfirm = msg('Discard Changes');
				state.dialog.labelCancel = msg('Stay on Form');
				document.addEventListener('confirm', () => updateRoute(state, action));
				document.dispatchEvent(new CustomEvent('open-dialog'));
			}
		},
		setStatus: (state, action) => {
			state = Object.assign(state, action.payload);
		},
		setLang: (state, action) => {
			state.lang = action.payload.lang;
		},
		setCurrentContentLanguage: (state, action) => {
			state.currentContentLanguage = action.payload;
		},
		setFormChanged: (state, action) => {
			state.formChanged = action.payload;
		},
		setHeaderDropdownState: (state, action) => {
			state.headerDropdownOpened = action.payload.id;
		},
		setShowArtworksFilter: (state, action) => {
			state.showArtworksFilter = action.payload.showArtworksFilter;
		},
		showMessage: (state, action) => {
			state.message = action.payload.message;
			state.messageType = action.payload.messageType;
			state.showMessage = true;
		},
		hideMessage: (state) => {
			state.showMessage = false;
			state.message = null;
			state.messageType = null;
		},
	},
});

export const {
	openDialog,
	closeDialog,
	setFormChanged,
	setCurrentContentLanguage,
	navigateTo,
	setStatus,
	setLang,
	setHeaderDropdownState,
	setShowArtworksFilter,
	showMessage,
	hideMessage,
} = statusSlice.actions;

export default statusSlice.reducer;
